jQuery(document).ready(function($){

    $('[data-number-minus]').click(function() {
        let $el = $(this).eq(0).siblings('input');
        let val = Math.max(parseInt($el.val()) - 1, 0);
        $el.val(val);
    });

    $('[data-number-plus]').click(function() {
        let $el = $(this).eq(0).siblings('input');
        let val = parseInt($el.val()) + 1;
        let max = parseInt($el.attr('max'));

        if (val > max) {
            return;
        }

        $el.val(val);
    });

    $('.modal-pricing input[type="number"]').on('input', function() {
        let value = this.value;
        let min = parseInt($(this).attr('min'));
        let max = parseInt($(this).attr('max'));

        if (value === '') {
            return;
        }

        value = parseInt(value);

        if (value < min) {
            this.value = 0;
        } else if (value > max) {
            this.value = max;
        }
    });

    $('.order__plan-item, .order__package-item').click(function() {
        let $el = $(this).find('input[type="radio"]').eq(0);
        $el.prop('checked', true);
    });

    function wm_calculate_price_prowizyjny() {
        let $el = $('input[name="monthly-reservations"]');
        let percentage = parseFloat(wm_vars.prowizyjny_percentage);
        let reservations = parseInt($el.val());
        let price = reservations ? (percentage / 100) * reservations : 0;

        price = Math.round(price * 100) / 100;
        price = price.toFixed(2);

        let $parent = $el.closest('.modal-pricing__tab');
        let $label = $parent.find('.modal-pricing__footer__price [data-price]');
        $label.text(price);
        $label.data('price', price);
    }

    function wm_calculate_price_plaski() {
        let $el = $('input[name="room-count"]');
        let rooms = parseInt($el.val());
        let price;

        let base_price = parseFloat(wm_vars.plaski_base_price);
        let room_price = parseFloat(wm_vars.plaski_room_price);

        if (rooms <= 12) {
            price = base_price;
        } else if (rooms >= 13) {
            price = base_price + (room_price * (rooms - 12));
        }

        price = Math.round(price * 100) / 100;
        price = price.toFixed(2);

        let $parent = $el.closest('.modal-pricing__tab');
        let $label = $parent.find('.modal-pricing__footer__price [data-price]');
        $label.text(price);
        $label.data('price', price);
    }

    if ($('input[name="monthly-reservations"]').length) {
        wm_calculate_price_prowizyjny();
    }

    $('input[name="monthly-reservations"]').on('keyup change blur', wm_calculate_price_prowizyjny);

    if ($('input[name="room-count"]').length) {
        wm_calculate_price_plaski();
    }

    $('input[name="room-count"]').on('keyup change blur', wm_calculate_price_plaski);

    $('.modal-pricing__tab :is([data-number-plus], [data-number-minus])').click(wm_calculate_price_plaski);

    $('input[name="package_type"]').change(function() {
        let slug = $(this).val();
        $('.modal-pricing__tab').removeClass('is-active');
        $(`[data-package-type="${slug}"]`).addClass('is-active');
    });
});
